export default (oldVal, newVal) => {
  if (!oldVal || !newVal) return 0;
  const percent = oldVal / 100;
  const result = ((newVal - oldVal) / percent)
    .toFixed(2)
    .replace(/\.?0+$/, ``);
  return parseFloat(result);
};
